/* 絞り込み検索モーダル（トレカショップサーカス カスタム）
   2026-08-23 / 2026-09-02 改修

   検索バーの「▽ 絞り込み検索」を押すと、その場でポップアップが開いて条件を選べる。

   ■ 2026-09-02 変更：検索バーと絞り込みを独立させる（客先要望）
   絞り込みUIは **常に全商品（/collections/all）を母集団**にして取得する。
   → 検索バーにキーワードやジャンルが入っていても、絞り込みの選択肢は減らない（全ジャンル・全ランク等が常に出る）。
   検索バーの内容は 「キーワード欣への事前入力」「該当ジャンルの事前チェック」として郍力。
   送信は JS が受け取り、キーワード有→/search、無→/collections/all に絞り込み条件を合成して遷移する。
   （「検索したあとでも絞り込みで一から探し直す」導線を確保するため。以前は検索結果を母集団にしていて選択肢が減っていた）

   ■ ネイティブ <dialog> を使う理由
   Escで閉じる・背景不活性・フォーカストラップがブラウザ標準で効く。テーマ独自ドローに依存しない。 */
(function () {
  var ALL_PRODUCTS_URL = '/collections/all'; // 絞り込みの母集団は常に全商品
  var GENRE_PARAM = 'filter.p.m.custom.genre';

  function init(root) {
    var trigger = root.querySelector('[data-filter-open]');
    var dialog = root.querySelector('[data-filter-dialog]');
    if (!trigger || !dialog) return;

    var body = dialog.querySelector('[data-filter-body]');
    var closers = dialog.querySelectorAll('[data-filter-close]');
    var genre = root.querySelector('[data-suggest-genre]');
    var input = root.querySelector('[data-suggest-input]');

    // 母集団は常に全商品。キーワードやジャンルで母集団を絞らない（選択肢を減らさないため）。
    function endpoint() {
      return ALL_PRODUCTS_URL + '?view=filters';
    }

    function currentKeyword() {
      return input && input.value ? input.value.trim() : '';
    }

    function wire(form) {
      var qInput = form.querySelector('[data-card-filter-q]');

      // 検索バーの内容を「反映」する：キーワードを事前入力、選択中ジャンルを事前チェック（選択肢は減らさない）
      if (qInput && currentKeyword()) qInput.value = currentKeyword();

      if (genre && genre.value) {
        var genreBoxes = form.querySelectorAll('input[type="checkbox"][name="' + GENRE_PARAM + '"]');
        for (var g = 0; g < genreBoxes.length; g++) {
          if (genreBoxes[g].value === genre.value) genreBoxes[g].checked = true;
        }
      }

      var clear = form.querySelector('[data-card-filter-clear]');
      if (clear) {
        clear.addEventListener('click', function () {
          var checks = form.querySelectorAll('input[type="checkbox"]');
          for (var i = 0; i < checks.length; i++) checks[i].checked = false;

          var numbers = form.querySelectorAll('input[type="number"]');
          for (var j = 0; j < numbers.length; j++) numbers[j].value = '';

          // ラジオ2択（在庫・セール品など）は「すべて表示」＝空の方に戻す
          var radios = form.querySelectorAll('input[type="radio"][value=""]');
          for (var k = 0; k < radios.length; k++) radios[k].checked = true;

          if (qInput) qInput.value = '';
        });
      }

      // 送信：キーワード＋絞り込み条件を合成して遷移する
      form.addEventListener('submit', function (event) {
        event.preventDefault();

        var params = new URLSearchParams();
        var kw = qInput && qInput.value ? qInput.value.trim() : '';

        var checks = form.querySelectorAll('input[type="checkbox"]');
        for (var i = 0; i < checks.length; i++) {
          if (checks[i].checked && !checks[i].disabled) params.append(checks[i].name, checks[i].value);
        }
        var radios = form.querySelectorAll('input[type="radio"]');
        for (var r = 0; r < radios.length; r++) {
          if (radios[r].checked && radios[r].value !== '') params.append(radios[r].name, radios[r].value);
        }
        var numbers = form.querySelectorAll('input[type="number"]');
        for (var n = 0; n < numbers.length; n++) {
          if (numbers[n].value !== '') params.append(numbers[n].name, numbers[n].value);
        }

        var dest;
        if (kw) {
          params.set('q', kw);
          params.set('type', 'product');
          dest = '/search?' + params.toString();
        } else {
          dest = ALL_PRODUCTS_URL + '?' + params.toString();
        }
        window.location.href = dest;
      });
    }

    function open() {
      body.innerHTML = '<p class="card-filter__loading">読み込み中…</p>';

      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        // 古いブラウザ向け。ここに落ちたらモーダルにせず一覸へ逃がす
        window.location.href = ALL_PRODUCTS_URL;
        return;
      }

      fetch(endpoint())
        .then(function (res) {
          if (!res.ok) throw new Error('filter request failed: ' + res.status);
          return res.text();
        })
        .then(function (html) {
          body.innerHTML = html;
          var form = body.querySelector('[data-card-filter-form]');
          if (form) wire(form);
        })
        .catch(function () {
          body.innerHTML =
            '<p class="card-filter__loading">条件を読み込めませんでした。' +
            '<a href="' + ALL_PRODUCTS_URL + '">一覴ページから絞り込む</a></p>';
        });
    }

    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      open();
    });

    for (var i = 0; i < closers.length; i++) {
      closers[i].addEventListener('click', function () {
        dialog.close();
      });
    }

    // 背景（dialog自身）のクリックで閉じる。中身のクリックでは閉じない
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });
  }

  function boot() {
    var roots = document.querySelectorAll('[data-card-suggest]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
